import * as DKFDS from 'dkfds';
import $ from 'jquery';

/*global deleteTemplateError, deleteTemplateModal */

function onClick() {
    if (!document.forms[0].chosenCase.value) {
        new DKFDS.Toast(deleteTemplateError).show();
    }
    else {
        new DKFDS.Modal(deleteTemplateModal).show();
    }
}

$(() => {
    $('#deleteTemplateButton').on('click', onClick);
    deleteTemplateModal.addEventListener('fds.modal.shown', () => {
        $('#deleteTemplateModalOK').one('click', () => {
            $('#deleteTemplateLoading').show();
            document.forms[0].delete.value = 'true';
            document.forms[0].submit();
        });
    });
});
